var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itemLoaded && _vm.routeDataLoaded)?_c('div',{staticClass:"admin-mailing-list"},[_c('b-row',[_c('b-col',[_c('h1',[_c('em',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc("mailing_lists.mailing_list", 1))))])])])],1),_c('b-row',[_c('b-col',[_c('mailing-list',{attrs:{"mailing-list":_vm.item}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }